[
  {
    "code": "DNI",
    "label": {
      "en": "National ID",
      "es": "DNI"
    },
    "order": 1,
    "is_active": true,
    "metadata": {
      "pattern": "^[0-9]{8}[A-Z]$"
    }
  },
  {
    "code": "NIE",
    "label": {
      "en": "Foreigner ID",
      "es": "NIE"
    },
    "order": 2,
    "is_active": true,
    "metadata": {
      "pattern": "^[XYZ][0-9]{7}[A-Z]$"
    }
  },
  {
    "code": "PASSPORT",
    "label": {
      "en": "Passport",
      "es": "Pasaporte"
    },
    "order": 3,
    "is_active": true
  },
  {
    "code": "DRIVERS_LICENSE",
    "label": {
      "en": "Driver's License",
      "es": "Permiso de conducir"
    },
    "order": 4,
    "is_active": true
  },
  {
    "code": "CIF",
    "label": {
      "en": "Company Tax ID",
      "es": "CIF"
    },
    "order": 5,
    "is_active": true,
    "metadata": {
      "pattern": "^[A-Z][0-9]{8}$"
    }
  },
  {
    "code": "VAT",
    "label": {
      "en": "VAT Number",
      "es": "NIF-IVA"
    },
    "order": 6,
    "is_active": true
  },
  {
    "code": "SSN",
    "label": {
      "en": "Social Security Number",
      "es": "Número de Seguridad Social"
    },
    "order": 7,
    "is_active": true
  },
  {
    "code": "TIN",
    "label": {
      "en": "Tax Identification Number",
      "es": "Número de Identificación Fiscal"
    },
    "order": 8,
    "is_active": true
  }
]
